import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Packages from "@/pages/Packages";
import FundRequest from "@/pages/FundRequest";
import Network from "@/pages/Network";
import StarClub from "@/pages/StarClub";
import StarClubNew from "@/pages/StarClubNew";
import PlayCard from "@/pages/PlayCard";
import DonationClub from "@/pages/DonationClub";
import IncomeHistory from "@/pages/IncomeHistory";
import Withdraw from "@/pages/Withdraw";
import Transfer from "@/pages/Transfer";
import Profile from "@/pages/Profile";
import AdminPanel from "@/pages/AdminPanel";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500">
        <div className="font-display text-2xl">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function PortalLayout({ children }) {
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/app" element={<Protected><PortalLayout><Dashboard /></PortalLayout></Protected>} />
          <Route path="/app/packages" element={<Protected><PortalLayout><Packages /></PortalLayout></Protected>} />
          <Route path="/app/fund-request" element={<Protected><PortalLayout><FundRequest /></PortalLayout></Protected>} />
          <Route path="/app/network" element={<Protected><PortalLayout><Network /></PortalLayout></Protected>} />
          <Route path="/app/star-club" element={<Protected><PortalLayout><StarClub /></PortalLayout></Protected>} />
          <Route path="/app/star-club-new" element={<Protected><PortalLayout><StarClubNew /></PortalLayout></Protected>} />
          <Route path="/app/play-card" element={<Protected><PortalLayout><PlayCard /></PortalLayout></Protected>} />
          <Route path="/app/donation-club" element={<Protected><PortalLayout><DonationClub /></PortalLayout></Protected>} />
          <Route path="/app/income" element={<Protected><PortalLayout><IncomeHistory /></PortalLayout></Protected>} />
          <Route path="/app/withdraw" element={<Protected><PortalLayout><Withdraw /></PortalLayout></Protected>} />
          <Route path="/app/transfer" element={<Protected><PortalLayout><Transfer /></PortalLayout></Protected>} />
          <Route path="/app/profile" element={<Protected><PortalLayout><Profile /></PortalLayout></Protected>} />

          <Route path="/admin" element={<Protected adminOnly><PortalLayout><AdminPanel /></PortalLayout></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
